import { getDealStatus } from '@/api/bamSearch/getDealStatus.ts';
import { webapi } from '@/api/webapi.ts';

export const dealStatusApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    getDealStatus: getDealStatus(builder),
  }),
});

export const { useGetDealStatusQuery } = dealStatusApi;
